'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = articleShareUrl;

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _origin = require('./origin');

var _origin2 = _interopRequireDefault(_origin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 正文分享地址
 * @param  {String}    options.ch
 * @param  {String}    options.business
 * @param  {String}    options.docId
 * @param  {String}    options.url
 * @param  {String}    options.env
 * @param  {String}    options.tagId
 * @param  {String}    options.tabId
 * @return {String}
 */
/*
 * @Author: edvardchen
 * @Date:   2017-03-16 16:03:26
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-09-23 12:06:53
 */

function articleShareUrl(_ref) {
  var _ref$ch = _ref.ch,
      ch = _ref$ch === undefined ? '060000' : _ref$ch,
      docId = _ref.docId,
      url = _ref.url,
      env = _ref.env,
      tagId = _ref.tagId,
      tabId = _ref.tabId;

  var base = (0, _origin2.default)(env) + '/share/' + docId;

  var params = {
    ch: ch,
    url: url,
    tagId: tagId,
    tabId: tabId
  };

  return base + '?' + _queryString2.default.stringify(params);
}